import { apiClient } from "@/services/api";

export default {
  billing() {
    return apiClient.get("/passes");
  },
  cancelPasses(data) {
    return apiClient.post("/passes/delete", data);
  },
  downloadInvoice(passId) {
    return apiClient.get(`/passes/${passId}/invoice`);
  }
};
